import { ethers as o } from "ethers";
import { ERC20ContractAbi as c } from "@deorderbook/contracts/abi";
import { signer as e, provider as s } from "./provider.mjs";
const a = /* @__PURE__ */ new Map(), i = (t) => {
  const r = new o.Contract(
    t,
    c
  );
  return a.set(t, r), r;
}, f = (t, r = !1) => {
  const n = i(t);
  return r ? n.connect(e) : n.connect(s);
};
export {
  a as erc20Contracts,
  i as initERC20Contract,
  f as useERC20Contract
};
//# sourceMappingURL=erc20Contract.mjs.map
